import React from 'react'
import { useIntl } from 'react-intl'

import { Order as OrderModel } from 'msp-integrations'

import AddressDisplay from '@/components/atoms/AddressDisplay/AddressDisplay'
import PaymentMethodDisplay from '@/components/molecules/PaymentMethodDisplay/PaymentMethodDisplay'

import translations from './OrderShipmentDetails.constants'
import * as S from './OrderShipmentDetails.styles'

const OrderShipmentDetails = ({ order }: { order: OrderModel }) => {
  const { formatMessage } = useIntl()

  return (
    <div className={S.Wrapper}>
      <div className={S.AddressesWrapper}>
        <div className={S.ShippingAddressWrapper}>
          <div className={S.InfoNameSpacing}>
            {formatMessage(translations.shippingAddress)}
          </div>
          <AddressDisplay address={order.getShipment()?.shippingAddress} />
        </div>
        <div className={S.BillingAddressWrapper}>
          <div className={S.InfoNameSpacing}>
            {formatMessage(translations.billingAddress)}
          </div>
          <AddressDisplay address={order.billingAddress} />
        </div>
      </div>
      <div className={S.ShippingAndPaymentWrapper}>
        <div className={S.PaymentInfoWrapper}>
          <div className={S.InfoNameSpacing}>
            {formatMessage(translations.paymentMethod)}
          </div>
          <PaymentMethodDisplay
            extendedDetails={false}
            paymentInstruments={order?.paymentInstruments}
          />
        </div>
        <div className={S.ShippingMethodInfoWrapper}>
          <div className={S.InfoNameSpacing}>
            {formatMessage(translations.shippingMethod)}
          </div>
          <div className={S.InfoNameSpacing}>
            {order.getShipment().shippingMethod.name}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderShipmentDetails
